// imports
import { fetchLocationApi } from 'api/location';

// ------------------------------------
// Constants
// ------------------------------------
export const FETCH_LOCATION_INFO_START = 'FETCH_LOCATION_INFO_START';
export const FETCH_LOCATION_INFO_END = 'FETCH_LOCATION_INFO_END';
export const LOCATION_INFO_ERROR = 'LOCATION_INFO_ERROR';

// ------------------------------------
// Actions
// ------------------------------------

export function fetchLocationInfoStart() {
  return ({ type: FETCH_LOCATION_INFO_START });
}

export function fetchLocationInfoEnd(payload) {
  return ({ type: FETCH_LOCATION_INFO_END, payload });
}

export function errorLocationInfo(payload) {
  return ({ type: LOCATION_INFO_ERROR, payload });
}

export function getLocation() {
  return (dispatch) => {
    dispatch(fetchLocationInfoStart());
    fetchLocationApi()
      .then((res) => {
        dispatch(fetchLocationInfoEnd(res));
      })
      .catch((err) => {
        dispatch(errorLocationInfo(err));
      });
  };
}

export function selectCountry(country) {
  return (dispatch) => {
    dispatch(fetchLocationInfoEnd(country));
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/location.js